class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    if (!this.mainDetailsToggle) return;

    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) {
      this.content = summary.nextElementSibling;
    }

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.content || !this.mainDetailsToggle) return;

    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    if (!this.mainDetailsToggle) return;

    this.mainDetailsToggle.removeAttribute('open');
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) {
      summary.setAttribute('aria-expanded', false);
    }
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.addEventListener('mouseenter', this.onHoverEnter.bind(this));
    this.addEventListener('mouseleave', this.onHoverLeave.bind(this));
    //console.log(this.onToggle)
  }

  onToggle() {
    if (!this.header) return;
    return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
  onHoverEnter() {
    this.querySelector('details').setAttribute('open','');
    this.header.setAttribute('megamenuopen','')
    this.querySelector('summary').setAttribute('aria-expanded','true');
  }
  onHoverLeave() {
    this.querySelector('details').removeAttribute('open');
    this.header.removeAttribute('megamenuopen','')
    this.querySelector('summary').setAttribute('aria-expanded','false');
    let megamenusecond = this.querySelectorAll('.secondary-links_inner');
    megamenusecond.forEach((seconditem)=>{
      seconditem.style.display = 'none';
    })
  }
}

customElements.define('header-menu', HeaderMenu);
